import Storage from "../storage";
import Alert from "../Alert";

const routeUser = (history) => {
  const currentUser = Storage.get("current-user");
  const keep = Storage.get("keep");

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let uploadStatus = user && user.is_upload;
  let userType = user && user.type;
  let changePasswordStatus = user && user.last_password_change;
  Storage.set("staffPassword", changePasswordStatus);

  if (userType === "nibss" || userType === "nibss_super_admin") {
    Alert(
      true,
      "danger",
      "Error message",
      "Only companies and staff can access this portal."
    );
    Storage.remove("current-user");
    Storage.remove("user-access-data");
    Storage.remove("user-access-token");
  } else {
    routingUser(
      currentUser,
      userType,
      changePasswordStatus,
      history,
      uploadStatus,
      keep
    );
  }
};

export default routeUser;

function routingUser(
  currentUser,
  userType,
  changePasswordStatus,
  history,
  uploadStatus,
  keep
) {
  if (currentUser && userType === "company_network_manager") {
    if (changePasswordStatus === null) {
      history.push("/user/verify");
    } else {
      history.push("/nip/integration");
    }
  } else {
    otherUserTypeRoutes(
      currentUser,
      uploadStatus,
      history,
      userType,
      changePasswordStatus,
      keep
    );
  }
}

function otherUserTypeRoutes(
  currentUser,
  uploadStatus,
  history,
  userType,
  changePasswordStatus,
  keep
) {
  if (currentUser && uploadStatus) {
    history.push("/dashboard");
  }
  if (currentUser && !uploadStatus) {
    history.push("/dashboard");
  }
  if (currentUser && userType === "staff" && changePasswordStatus !== null) {
    history.push("/dashboard", keep);
  }
  if (currentUser && userType === "staff" && changePasswordStatus === null) {
    history.push("/user/verify");
  }
}
